import { Typography } from '@material-ui/core'
import { useState } from 'react'

import { ComLog } from '../../../types/monitoring'
import MonitoringFormViewMoreInfoModal from '../MonitoringFormViewMoreInfoModal'
import MonitoringRowMenu from '../MonitoringRowMenu'
import useStyles from './styles/MonitoringFormListRow.styles'

interface MonitoringFormListRowMobileProps {
  data: ComLog
}
const MonitoringFormListRowMobile: React.FC<
  MonitoringFormListRowMobileProps
> = ({ data }) => {
  const classes = useStyles()
  const [viewRequestIsOpen, setviewRequestIsOpen] = useState<boolean>(false)
  const [viewResponseIsopen, setviewResponseIsopen] = useState<boolean>(false)
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">
          {data.EndpointName.substr(data.EndpointName.indexOf('.'), 20)}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{data.Status}</Typography>
      </div>
      <div className={classes.moreIcon}>
        <MonitoringRowMenu
          viewRequest={() => setviewRequestIsOpen(true)}
          viewResponse={() => setviewResponseIsopen(true)}
        />
      </div>
      <MonitoringFormViewMoreInfoModal
        requestView={JSON.parse(data.Request)}
        isOpen={viewRequestIsOpen}
        onClose={() => setviewRequestIsOpen(false)}
      />
      <MonitoringFormViewMoreInfoModal
        requestView={JSON.parse(data.Response)}
        isOpen={viewResponseIsopen}
        onClose={() => setviewResponseIsopen(false)}
      />
    </div>
  )
}
export default MonitoringFormListRowMobile
